module.exports = __webpack_public_path__ + "static/Webster-Ave-Laundromat-1363-Webster-Ave-Bronx-NY-10456-0d818e2cbb65b3ff73b5e19c3aa2d955.jpg";